import React from "react";
import { Box, Typography, Button } from "@mui/material";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            textAlign: "center",
            py: 8,
            px: 3,
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "1.5rem", md: "2rem" },
              fontWeight: 700,
              color: "#081B44",
              fontFamily: "'Playfair Display', serif",
              mb: 2,
            }}
          >
            Something went wrong
          </Typography>
          <Typography
            sx={{
              fontSize: "1rem",
              color: "#6B7280",
              mb: 4,
            }}
          >
            We're sorry for the inconvenience. Please try again.
          </Typography>
          <Button
            variant="contained"
            onClick={this.handleReset}
            sx={{
              bgcolor: "#C59324",
              color: "#FFF",
              fontWeight: 700,
              textTransform: "none",
              "&:hover": { bgcolor: "#A67C1E" },
            }}
          >
            Try Again
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
